import { useState } from "react";
import { getRelativeTime } from "../../../utils/date/DateUtils";
import { useSelector } from "react-redux";

function CommentThread({
  comments,
  likes = 0,
  dislikes = 0,
  userVote = 0,
  onVote,
  onPostComment,
}) {
  const [newComment, setNewComment] = useState("");
  const [replyText, setReplyText] = useState("");
  const user = useSelector((state) => state.auth.user);
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const userAvatar =
    isAuthenticated && user?.avatar
      ? user.avatar
      : `${process.env.PUBLIC_URL}/images/avatar_settings.svg`;

  // Helper to determine which icon to show
  const getLikeIcon = () => {
    return userVote === 1
      ? `${process.env.PUBLIC_URL}/images/icons/like_dark.svg`
      : `${process.env.PUBLIC_URL}/images/icons/like_gray.svg`;
  };

  const getDislikeIcon = () => {
    return userVote === -1
      ? `${process.env.PUBLIC_URL}/images/icons/dislike_dark.svg`
      : `${process.env.PUBLIC_URL}/images/icons/dislike_gray.svg`;
  };

  const handleSubmit = () => {
    if (!newComment.trim()) return;
    onPostComment(newComment); // Pass text to the parent (Article)
    setNewComment(""); // Clear input after sending
  };

  return (
    <div className="comments-container">
      <div className="comments-reactions">
        <div className="comments-likes">
          <div
            id="like"
            onClick={() => onVote(1)}
            style={{ cursor: "pointer" }}
          >
            <img src={getLikeIcon()} />
            <span
              style={{
                color: userVote === 1 ? "#002a52" : "#8c9093",
              }}
            >
              {likes}
            </span>
          </div>
          <div
            id="dislike"
            onClick={() => onVote(-1)}
            style={{ cursor: "pointer" }}
          >
            <img src={getDislikeIcon()} />
            <span
              style={{
                color: userVote === -1 ? "#002a52" : "#8c9093",
              }}
            >
              {dislikes}
            </span>
          </div>
        </div>
      </div>
      <div className="comments-list-container">
        <div className="give-comment-header">
          <div className="give-comment-avatar">
            <img
              src={userAvatar}
              alt="User Avatar. Default Plaintr avatar for guest"
            />
          </div>
          <div className="give-comment-form">
            <textarea
              className="type-comment-container"
              placeholder="Leave your comment"
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
            />
            <button
              className="cta-button primary"
              onClick={handleSubmit}
              disabled={!newComment.trim()}
            >
              COMMENT
            </button>
          </div>
        </div>
        {comments.map((comment) => (
          <div key={comment.id} className="single-comment-replies">
            <div className="single-comment">
              <div className="comment-meta">
                <div className="comment-avatar">
                  <img
                    src={
                      comment.user_avatar ||
                      `${process.env.PUBLIC_URL}/images/avatar_settings.svg`
                    }
                    alt="avatar"
                  />
                </div>
                <div className="comment-meta-container">
                  <div className="comment-meta-header">
                    <h4>{comment.user_name}</h4>
                    <span>{getRelativeTime(comment.created_at)}</span>
                  </div>
                  <div className="comment-meta-content">
                    <div className="comment-desc">
                      <p>{comment.content}</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Replies Section */}
              <div className="comment-replies">
                {/* Reply Input */}
                <div className="give-comment-form">
                  <textarea
                    className="type-comment-container"
                    placeholder="Reply"
                    value={replyText[comment.id] || ""}
                    onChange={(e) =>
                      setReplyText({
                        ...replyText,
                        [comment.id]: e.target.value,
                      })
                    }
                  />
                  <button
                    className="cta-button primary"
                    onClick={() =>
                      onPostComment(replyText[comment.id], comment.id)
                    }
                    disabled={!replyText[comment.id]?.trim()}
                  >
                    Reply
                  </button>
                </div>

                {/* Render Nested Replies */}
                {comment.replies &&
                  comment.replies.map((reply) => (
                    <div key={reply.id} className="single-reply">
                      <div className="comment-avatar">
                        <img
                          src={
                            reply.user_avatar ||
                            `${process.env.PUBLIC_URL}/images/avatar_settings.svg`
                          }
                          alt="avatar"
                        />
                      </div>
                      <div className="comment-meta-container">
                        <div className="comment-meta-header">
                          <h4>{reply.user_name}</h4>
                          <span>{getRelativeTime(reply.created_at)}</span>
                        </div>
                        <p>{reply.content}</p>
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CommentThread;
